import { BrowserRouter as Router, Routes, Route, useParams } from "react-router-dom"
import PremiumHome from "./PremiumHome"
import Home from "./Home"
import CourseIntro from "./CourseIntro"
import ProjectsPage from "./ProjectsPage"
import StudentsPage from "./StudentsPage"
import EnterprisePage from "./EnterprisePage"
import FacultyPage from "./FacultyPage"
import ProjectDetail from "./ProjectDetail"
import Connect from "./Connect"

function AppRouter() {
  // 包装组件以传递路由参数
  function ProjectDetailWrapper() {
    const { id } = useParams();
    return <ProjectDetail id={id} />;
  }
  
  function FacultyDetailWrapper() {
    const { id } = useParams();
    return <Connect id={id} />;
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/premium-home" element={<PremiumHome />} />
        <Route path="/home" element={<Home />} />
        <Route path="/course-intro" element={<CourseIntro />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/students" element={<StudentsPage />} />
        <Route path="/enterprise" element={<EnterprisePage />} />
        <Route path="/faculty" element={<FacultyPage />} />
        <Route path="/faculty-detail/:id" element={<FacultyDetailWrapper />} />
        <Route path="/project/:id" element={<ProjectDetailWrapper />} />
        <Route path="/student/:id" element={<ProjectDetailWrapper />} />
        <Route path="/enterprise-project/:id" element={<ProjectDetailWrapper />} />
      </Routes>
    </Router>
  )
}

export default AppRouter